
export default function Testimonials() {
  return (
    <>
      {/* Who We Work With Section */}
      <section id="who-we-work-with" className="py-24 px-6 lg:px-12 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#FAFAF9] px-4 py-2 rounded-full mb-6">
              <span className="w-2 h-2 bg-[#093a3e] rounded-full animate-pulse"></span>
              <span className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Who We Work With</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Built for healthcare organizations accountable for quality.
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {/* Health Plans */}
            <div className="bg-[#FAFAF9] rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-[#093a3e]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-[#093a3e] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Health Plans
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Medicare Advantage, Medicaid, and Commercial plans looking to improve Stars ratings and close quality gaps.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Stars measure improvement</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Member engagement</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Quality gap closure</span>
                </li>
              </ul>
            </div>

            {/* Health Systems */}
            <div className="bg-[#FAFAF9] rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-[#093a3e]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-[#093a3e] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Health Systems & Provider Groups
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Integrated delivery networks and large practices seeking to embed preventive screening into routine care.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Point-of-care integration</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Workflow efficiency</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Patient outcomes</span>
                </li>
              </ul>
            </div>

            {/* ACOs */}
            <div className="bg-[#FAFAF9] rounded-2xl p-8 hover:shadow-xl transition-all">
              <div className="w-16 h-16 bg-[#093a3e]/20 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-team-line text-[#093a3e] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                ACOs & Value-Based Risk Organizations
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Organizations with shared savings or capitated arrangements that benefit from preventive care delivery.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Risk-adjusted performance</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Cost avoidance</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <i className="ri-check-line text-[#093a3e]"></i>
                  <span className="text-sm">Quality incentives</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center">
            <a
              href="/who-we-work-with"
              className="inline-flex items-center gap-2 bg-[#093a3e] text-white px-8 py-4 rounded-full hover:bg-[#062b2f] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap font-semibold group"
            >
              <span>Explore Use Cases</span>
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Risk-Sharing Section */}
      <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-[#093a3e] to-[#062b2f]">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Low lift. Low risk. High upside.
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Kinra offers commercial structures that align incentives—so you can launch quickly without betting the budget upfront. We charge for incremental impact and can tie upside to realized quality performance improvements.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-white text-[#093a3e] px-8 py-4 rounded-full hover:bg-gray-50 transition-all hover:shadow-lg cursor-pointer whitespace-nowrap font-semibold group"
          >
            <span>Discuss Pricing & Risk-Sharing</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </section>
    </>
  );
}
